<template>
    <div>
        <b-card v-show="mostrarTabela" no-body>
            <b-card-body>
                <app-tabela
                    idTabela="tblComissionamentos"
                    :itens="comissionamentos"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="botoes">
                        <btn-inserir-comissionamento
                            @obterNovasComissoes="obterComissionamentos()"
                            :contrato="contrato"
                        />
                    </template>

                    <template slot="status" slot-scope="data">
                        <app-status
                            :status="data.statusDescr.toUpperCase()"
                        ></app-status>
                    </template>

                    <template slot="prazo" slot-scope="data">
                        {{
                            data.dataInicio
                                ? $moment(data.dataInicio).format('DD/MM/YYYY')
                                : ''
                        }}
                        <span v-if="data.dataInicio">a</span>
                        {{
                            data.dataFinal
                                ? $moment(data.dataFinal).format('DD/MM/YYYY')
                                : ''
                        }}
                    </template>

                    <template slot="porcentagemComissao" slot-scope="data">
                        <span class="text-nowrap"
                            >{{ data.porcentagemComissao }}%</span
                        >
                    </template>

                    <template slot="recorrente" slot-scope="data">
                        {{ data.recorrente == true ? 'SIM' : 'NÃO' }}
                    </template>

                    <template slot="codContrato" slot-scope="data">
                        {{ data.contratoComissionado.vcCodigoEstruturado }}
                    </template>

                    <template slot="fornecedor" slot-scope="data">
                        {{ data.contratoComissionado.fornecedor.nome }}
                    </template>

                    <template slot="acoes" slot-scope="data">
                        <BtnAtualizarComissionamento
                            :comissionamento="data"
                            @obterNovasComissoes="obterComissionamentos()"
                        />
                        <BtnExcluirComissionamento
                            :comissionamento="data"
                            @obterComissoesAtualizadas="obterComissionamentos()"
                        />
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <router-view></router-view>
    </div>
</template>

<script>
import ComissionamentosServicos from './comissionamentosServicos'
import BtnExcluirComissionamento from './BtnExcluirComissionamento.vue'
import BtnInserirComissionamento from './BtnInserirComissionamento.vue'
import BtnAtualizarComissionamento from './BtnAtualizarComissionamento.vue'
export default {
    components: {
        BtnExcluirComissionamento,
        BtnInserirComissionamento,
        BtnAtualizarComissionamento
    },

    props: {
        contrato: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            comissionamentos: [],
            itensPorPagina: 50,
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'fornecedor',
                    label: 'Fornecedor',
                    sortable: true,
                },
                {
                    key: 'codContrato',
                    label: 'Código do Contrato',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'recorrente',
                    label: 'Recorrente',
                    sortable: true
                },
                {
                    key: 'porcentagemComissao',
                    label: ' Percentual da Comissão',
                    sortable: true
                },
                {
                    key: 'prazo',
                    label: 'Prazo'
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true,
                },

            ]
        }
    },
    methods: {
        obterComissionamentos() {
            this.$store.dispatch('addRequest')
            ComissionamentosServicos.obterTodasComissoes(
                this.$route.params.contratoId
            ).then((response) => {
                if (response && response.success) {
                    this.comissionamentos = response.data
                } else {
                    this.$toast.error(response.errors, 'ERROR', this.error)
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {
        this.obterComissionamentos()
    },

    computed: {
        mostrarTabela() {
            return this.$route.name === 'Contratos_Detalhar'
        }
    },

    watch: {
        $route(to, from) {
            if (to.name === 'Contratos_Comissionamentos') {
                if (
                    this.$store.getters.recarregar ||
                    from.name == 'Contratos_Comissionamentos'
                ) {
                    this.obterComissionamentos()
                    this.$store.dispatch('setRecarregar', false)
                }
            }
        },

    }
}
</script>
